/**
 * TRANSLATIONS
 */
export const getTranslateSelectedOption = (selectedOption, type, i18n) => {
    if (i18n && selectedOption.value === type) {
        const updatedLabel = `Report Filters - ${type}`;

        return {
            ...selectedOption,
            label: i18n._(updatedLabel)
        };
    }

    return selectedOption;
};

export const getTranslatedOptions = (options, type, i18n) => {
    if (i18n) {
        return options.map((item) => {
            if (item.value === type) {
                const updatedLabel = `Report Filters - ${type}`;
                return {
                    ...item,
                    label: i18n._(updatedLabel)
                };
            }

            return item;
        });
    }

    return options;
};



// WEBPACK FOOTER //
// ./components/report-filters/dropdown-menus/dropdown-helpers.js